import { useMutation } from '@tanstack/react-query';

import { logger } from '@/utils';

import { updateUserProfile } from '../api';
import { settingsQueryKeys } from '../data';

export const useUpdateUserProfileMutation = () => {
  const mutation = useMutation({
    mutationKey: settingsQueryKeys.updateUserProfile,

    mutationFn: updateUserProfile,

    onMutate: (data) => {
      return { ...data };
    },

    onSuccess: (data) => {
      logger.log(data);
    },

    onError: (error) => {
      logger.log(error);
    },
  });

  return mutation;
};
